var _defs, _style, _g, _path, _g2, _g3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWalletButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137 137",
    width: 137,
    height: 137,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add-wallet-button-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-26.652,-3.405,3.405,-26.652,30.37,39.514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#546677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,80,-80,0,68.5,28.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#101116"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272734"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #22222a } \n\t\t.s1 { opacity: .7;fill: none;stroke: #363e45;stroke-width: .5 } \n\t\t.s2 { fill: none;stroke: url(#g1);stroke-width: 6;stroke-dasharray: 0.9999999999999998 } \n\t\t.s3 { fill: url(#g2) } \n\t\t.s4 { fill: none;stroke: #000000;stroke-width: 1 } \n\t\t.s5 { fill: none;stroke: #73f6ff;stroke-linecap: round;stroke-width: 2 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m68.5 135.5c-37.1 0-67-29.9-67-67 0-37.1 29.9-67 67-67 37.1 0 67 29.9 67 67 0 37.1-29.9 67-67 67z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m68.5 135.8c-37.2-0.1-67.3-30.1-67.3-67.3 0.1-37.2 30.1-67.3 67.3-67.3 37.2 0 67.3 30.1 67.3 67.3 0 37.2-30.1 67.2-67.3 67.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m68.5 122.5c-29.9 0-54-24.1-54-54 0-29.9 24.1-54 54-54 29.9 0 54 24.1 54 54 0 29.9-24.1 54-54 54z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m68.5 108.5c-22.1 0-40-17.9-40-40 0-22.1 17.9-40 40-40 22.1 0 40 17.9 40 40 0 22.1-17.9 40-40 40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m68.5 109c-22.4 0-40.5-18.1-40.5-40.5 0-22.4 18.1-40.5 40.5-40.5 22.4 0 40.5 18.1 40.5 40.5 0 22.4-18.1 40.5-40.5 40.5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m68.5 58.1v22.8m11.4-11.4h-22.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWalletButton);
export default __webpack_public_path__ + "static/media/add-wallet-button.139d0ca379798789fa9531c6a7debc3c.svg";
export { ForwardRef as ReactComponent };